import { render, staticRenderFns } from "./welderWeight.vue?vue&type=template&id=6fe85bd9&scoped=true"
import script from "./welderWeight.vue?vue&type=script&lang=js"
export * from "./welderWeight.vue?vue&type=script&lang=js"
import style0 from "./welderWeight.vue?vue&type=style&index=0&id=6fe85bd9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe85bd9",
  null
  
)

export default component.exports